/// <reference path="../typings/Common.d.ts" />

import * as React from "react";

import {TransactionType} from '../utils/Common'
import ConfigurationDataHeader from './ConfigurationDataHeader';
import ConfigurationHelp from './ConfigurationHelp';

export interface IConfigurationDataProps {
    activeData?: IConfigurationData,
    checkPriority: (data: IConfigurationData, priority: number) => boolean,
    changeState: (data: IConfigurationData) => void,
    newConfigurationClick: () => void,
    isNewConfiguration: boolean,
    isSelected: boolean,
    saveConfiguration: () => void,
    deleteConfiguration: () => void
}

export default class ConfigurationData extends React.Component<IConfigurationDataProps, any> {

    constructor() {
        super();

        this.onNewConfigurationClick = this.onNewConfigurationClick.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.saveClick = this.saveClick.bind(this);
        this.deleteClick = this.deleteClick.bind(this);
    }
    
    deleteClick(event: any) {
        event.preventDefault();
        this.props.deleteConfiguration();
    }

    saveClick(event: any) {
        event.preventDefault();
        this.props.saveConfiguration();
    }

    handleNameChange(event: any) {
        this.props.changeState({ Name: event.target.value });
    }

    handleJsonChange(isRequest: boolean, event: any) {
        if (isRequest) {
            this.props.changeState({ MatchingJson: event.target.value });
        } else {
            this.props.changeState({ Result: event.target.value });
        }
    }

    handlePriorityChange(event: any) {
        this.props.changeState({Priority: event.target.value});
    }

    handleTypeChange(event: any) {
        this.props.changeState({Type: event.target.value});
    }

    onNewConfigurationClick(event: any) {
        event.preventDefault();
        this.props.newConfigurationClick();
    }
    
    checkJsonError(json: string) {
        try {
            if (json && json !== "") {
                JSON.parse(json);
            }
            
            return null;
        } catch (error) {
            return error.message;
        }
    }

    render() {
        var matchingJson = "";
        var result = "";

        try {
            matchingJson = JSON.stringify(JSON.parse(this.props.activeData.MatchingJson), undefined, 4);
            result = JSON.stringify(JSON.parse(this.props.activeData.Result), undefined, 4);
        } catch (err) {

        }

        var activeData: IConfigurationData = {
            Guid: '',
            Type: '',
            Priority: null,
            Name: null,
            MatchingJson: null,
            Result: null
        };
        if (this.props.activeData)
            activeData = this.props.activeData;
        
        var priorityError = activeData && !this.props.checkPriority(activeData, activeData.Priority);
        var requestError = activeData && this.checkJsonError(activeData.MatchingJson);
        var responseError = activeData && this.checkJsonError(activeData.Result);
            
        if (this.props.isNewConfiguration && activeData && (!activeData.MatchingJson || activeData.MatchingJson == '')) {
            requestError = "Cannot be empty";
        }
        if (this.props.isNewConfiguration && activeData && (!activeData.Result || activeData.Result == '')) {
            responseError = "Cannot be empty";
        }
        if (this.props.isNewConfiguration && activeData && (!activeData.Priority || activeData.Priority == 0)) {
            priorityError = true;
        }

        var requestClassName = (requestError ? 'has-error' : 'has-success');
        var responseClassName = (responseError ? 'has-error' : 'has-success');
        var allSuccess = !priorityError && !requestError && !responseError;

        var typeDropDown: any;
        if (this.props.isNewConfiguration) {
            var options: Array<any> = [];
            for (var i = 0; i < TransactionType.FINAL_ENUM; ++i) {
                options.push(<option key={TransactionType[i]}>{TransactionType[i]}</option>);
            }

            typeDropDown = (
                <div className="form-group form-group-lg">
                    <label className="col-md-1 control-label"><strong>Type</strong>: </label>
                    <div className="col-md-10">
                        <select className="form-control" onChange={this.handleTypeChange}>
                            {options}
                        </select>
                    </div>
                </div>);
        }
        
        if (activeData && activeData.MatchingJson && (!matchingJson || matchingJson == "")) {
            matchingJson = activeData.MatchingJson;
        }
        if (activeData && activeData.Result && (!result || result == "")) {
            result = activeData.Result;
        }

        var matchingRequestTooltip = "In order to reponse only to some requests add Request properties that are going to be used as filter";
        
        return (
            <div>
                <ConfigurationDataHeader isSelected={this.props.isSelected}
                                         isNewConfiguration={this.props.isNewConfiguration}
                                         onNewConfigurationClick={this.onNewConfigurationClick}/>
                <div className="row panel panel-default mainGridHeader">
                    <form className="form-horizontal">
                        {typeDropDown}
                        <div className="form-group form-group-lg">
                            <label className="col-md-1 control-label"><strong>Priority</strong>: </label>
                            <div className={"col-md-4 " + (priorityError ? 'has-error' : 'has-success') }>
                                <input className="form-control" type="number"
                                    value={"" + activeData.Priority}
                                    onChange={this.handlePriorityChange.bind(this) } />
                                {
                                priorityError ? (<span className="help-block">Such priority already exists</span>) : ''
                                }
                                </div>
                            <label className="col-md-1 control-label">Name: </label>
                            <div className="col-md-4">
                                <input className="form-control" type="text"
                                    value={"" + activeData.Name}
                                    onChange={this.handleNameChange.bind(this) } />
                                </div>
                                <div className="col-md-1">
                                    <button type="button" 
                                            className="btn btn-primary btn-lg" 
                                            style={{ width: 100, marginBottom: "5px" }} 
                                            disabled={!allSuccess}
                                            onClick={this.saveClick}>Save</button>
                                    { activeData && activeData.Guid 
                                        ? <button type="button" 
                                            className="btn btn-primary" 
                                            style={{ width: 100 }} 
                                            onClick={this.deleteClick}>Delete</button>
                                        : "" }
                                </div>
                            </div>
                        <div className="form-group" style={{ margin: "5px" }}>
                            <div className={"col-md-5 " + requestClassName}
                                 title={matchingRequestTooltip}>
                                <span className="lead"><strong>Matching Request</strong></span>
                                <textarea className="form-control" 
                                    cols={100} 
                                    rows={30} 
                                    aria-describedby="requestHelpBlock"
                                    style={{height: "300px"}}
                                    value={matchingJson}
                                    onChange={this.handleJsonChange.bind(this, true) }
                                    />
                                <span id="requestHelpBlock" className="help-block">{requestError}</span>
                                <span>{matchingRequestTooltip}</span>
                            </div>
                            <div className={"col-md-5 " + responseClassName}>
                                <span className="lead"><strong>Response</strong></span>
                                <textarea className="form-control" 
                                    cols={100} 
                                    rows={30}
                                    value={result}
                                    style={{height: "300px"}}
                                    onChange={this.handleJsonChange.bind(this, false) } />
                                <span className="help-block">{responseError}</span>
                            </div>
                        </div>
                    </form>
                </div>
                <ConfigurationHelp type={activeData.Type}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/ConfigurationData.tsx